import {
  BadgeCheck,
  CircleDollarSign,
  ClipboardList,
  FileSignature,
  FileText,
  Gauge,
  Hourglass,
  Mail,
  MessageSquare,
  ReceiptText,
  Send,
  Sparkles,
  Trophy,
  Users,
  type LucideIcon,
} from "lucide-react";

/**
 * Maps a guidance step `code` to its lucide icon — the same per-step icons the
 * deal/customer setup checklists used, so the guidance card stays scannable.
 * Guidance from the server carries no icon (presentation lives here).
 */
const ICONS: Record<string, LucideIcon> = {
  // Deal — non-RFQ
  propose_or_close: Send,
  add_commissions: CircleDollarSign,
  complete_details: ClipboardList,
  close_deal: Trophy,
  // Deal — RFQ
  add_customer_account: Gauge,
  associate_accounts: Gauge,
  collect_loa: FileSignature,
  create_rfq: Mail,
  send_rfq: Mail,
  receive_quotes: Hourglass,
  add_contact: Users,
  generate_proposal: FileText,
  record_response: MessageSquare,
  close_won: BadgeCheck,
  // Customer
  loa: FileSignature,
  bills: ReceiptText,
  contacts: Users,
};

export function iconForGuidanceCode(code: string): LucideIcon {
  return ICONS[code] ?? Sparkles;
}
